import { axios } from 'shared/services/axios'

export function fetchOrganizationSettings(boardId) {
  return axios.get(`/live_board/v1/boards/${boardId}/organization_settings`)
    .then(response => response.data)
}